import { getOr } from 'lodash/fp';

export default (err) => {
  console.log('error', getOr(err, ['stack'], err));
};
